import React, {useState} from 'react';
import auth from "../../network/services/auth";
import passwordRequestModel from "../../network/models/quick_models";
import {getUserAuth, isAllowed, isAuthenticated, setUserAuth} from "../../helpers/authenticator";

const LoginFormPassword = ({change}) => {
    const [password, setPassword] = useState('');

    const handlePassword = (event) => {
        setPassword(event.target.value)
    };

    const loader = () => {
        change.callback({
            state: true,
            componentType: "loading",
            phone: change.current.phone,
            refId: change.current.refId
        });
    };

    const submitForm = () => {
        loader();
        let data = passwordRequestModel.passwordRequest;
        data.password = password;
        data.phone_number = change.current.phone;
        data.reference_id = change.current.refId;

        auth.userLoginIn(data).then(response => {
            setUserAuth(response.data.data);
            change.callback({
                state: true,
                componentType: "redirect",
                phone: "",
                refId: ""
            });
        }).catch(error => {
            change.callback({
                state: true,
                componentType: "password",
                phone: change.current.phone,
                refId: change.current.refId
            });
        });
    };

    if (change.current.isActive) {
        submitForm()
    }
    return (
        <div className="row justify-content-center">
            <div className="col-md-5 col-lg-5 col-sm-5">
                <div className="text-left">
                    <ul className="list-unstyled">
                        <li>
                            <h6 className="header-text">
                                Enter your password
                            </h6>
                        </li>
                        <li style={{marginTop: 35}}>
                            <div className="input-group">
                                <input type="text" className="form-control form-control-lg input-form-alt"
                                       placeholder="Password" onChange={handlePassword}
                                       aria-label="Username" aria-describedby="basic-addon1"/>
                            </div>
                        </li>
                        <li>
                            <p style={{color: "#006CFF", fontSize: 11.5}}>Forgot password</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>);
};

export default LoginFormPassword;
